module.exports = __webpack_public_path__ + "img/page_4.93f69e68.png";